// App.js 수정 완료
import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { isAuthenticated } from './services/auth';
import Header from './components/Header';
import Footer from './components/Footer';
import Popup from './components/Popup';
import Home from './pages/Home';
import ProductDetail from './pages/ProductDetail';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import Wishlist from './pages/Wishlist';
import Login from './pages/Login';
import Register from './pages/Register';
import Profile from './pages/Profile';
import FindUsername from './pages/FindUsername';
import FindPassword from './pages/FindPassword';
import VerifyEmail from './pages/VerifyEmail';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import BusinessInfo from './pages/BusinessInfo';
import PointHistory from './pages/PointHistory';
import Coupons from './pages/Coupons';
import BestProducts from './pages/BestProducts';
import NewProducts from './pages/NewProducts';
import OrderDetail from './pages/OrderDetail';
import ReviewWrite from './pages/ReviewWrite';
import RefundRequestPage from './pages/refund/RefundRequestPage';  // ⭐ 이것만 사용

// 게시판
import Notice from './pages/Notice';
import NoticeDetail from './pages/NoticeDetail';
import FAQ from './pages/FAQ';
import Inquiry from './pages/Inquiry';
import InquiryWrite from './pages/InquiryWrite';
import InquiryDetail from './pages/InquiryDetail';

// ⭐ 마이페이지
import MyPage from './pages/MyPage';
import Orders from './pages/orders';
import ChangePassword from './pages/ChangePassword';

import './App.css';

function PrivateRoute({ children }) {
	const location = useLocation();
	
	if (!isAuthenticated()) {
		localStorage.setItem('redirectPath', location.pathname + location.search);
		return <Navigate to="/login" />;
	}
	
	return children;
}

function App() {
	const location = useLocation();
	
	// ⭐ 페이지 이동 시 맨 위로 스크롤
	useEffect(() => {
		window.scrollTo(0, 0);
	}, [location.pathname]);
	
	return (
		<div className="App">
			<Popup />
			<Header />
			
			<main className="main-content">
				<Routes>
					<Route path="/" element={<Home />} />
					<Route path="/product/:id" element={<ProductDetail />} />
					<Route path="/cart" element={<Cart />} />
					<Route path="/best" element={<BestProducts />} />
					<Route path="/new" element={<NewProducts />} />
					<Route path="/checkout" element={
						<PrivateRoute>
							<Checkout />
						</PrivateRoute>
					} />
					<Route path="/wishlist" element={
						<PrivateRoute>
							<Wishlist />
						</PrivateRoute>
					} />
					<Route path="/profile" element={
						<PrivateRoute>
							<Profile />
						</PrivateRoute>
					} />
					
					{/* ⭐ 환불 신청 페이지 */}
					<Route path="/refund/:orderId/:itemId" element={
						<PrivateRoute>
							<RefundRequestPage />
						</PrivateRoute>
					} />
					
					{/* ⭐ 마이페이지 */}
					<Route path="/mypage" element={
						<PrivateRoute>
							<MyPage />
						</PrivateRoute>
					} />
					
					{/* ⭐ 주문내역 (통합) */}
					<Route path="/orders" element={
						<PrivateRoute>
							<Orders />
						</PrivateRoute>
					} />
					
					{/* ⭐ 포인트 내역 */}
					<Route path="/mypage/points" element={
						<PrivateRoute>
							<PointHistory />
						</PrivateRoute>
					} />
					
					{/* ⭐ 쿠폰함 */}
					<Route path="/mypage/coupons" element={
						<PrivateRoute>
							<Coupons />
						</PrivateRoute>
					} />
					
					{/* ⭐ 비밀번호 변경 */}
					<Route path="/mypage/change-password" element={
						<PrivateRoute>
							<ChangePassword />
						</PrivateRoute>
					} />
					
					<Route path="/login" element={<Login />} />
					<Route path="/register" element={<Register />} />
					<Route path="/verify-email" element={<VerifyEmail />} />
					<Route path="/find-username" element={<FindUsername />} />
					<Route path="/find-password" element={<FindPassword />} />
					<Route path="/terms" element={<Terms />} />
					<Route path="/privacy" element={<Privacy />} />
					<Route path="/business-info" element={<BusinessInfo />} />
					<Route path="/orders/:id" element={<OrderDetail />} />
					<Route path="/review/write" element={<ReviewWrite />} />
					
					{/* 게시판 */}
					<Route path="/notice" element={<Notice />} />
					<Route path="/notice/:id" element={<NoticeDetail />} />
					<Route path="/faq" element={<FAQ />} />
					<Route path="/inquiry" element={
						<PrivateRoute>
							<Inquiry />
						</PrivateRoute>
					} />
					<Route path="/inquiry/write" element={
						<PrivateRoute>
							<InquiryWrite />
						</PrivateRoute>
					} />
					<Route path="/inquiry/:id" element={
						<PrivateRoute>
							<InquiryDetail />
						</PrivateRoute>
					} />
				</Routes>
			</main>
			
			<Footer />
		</div>
	);
}

export default App;